import { useAppSelector } from 'shared/store/store'
import { UserRoleEnum } from 'shared/models/User'
import { getActiveClient } from 'shared/store/clients/selectors'
import { getUser } from 'shared/store/user/selectors'
import {
  hasAdvisorRolesForClient,
  hasBoardRoleForClient,
  hasCaretakerRolesForClient,
  hasOnlyStyrePortalBrukerAndAdvisor,
  hasBoardMemberRolesForClient,
  hasPortalAccess,
  hasJanitorRoleForClient,
  hasAuditorRolesForClient,
  hasOwnerAccess,
  hasCEORoleForClient,
} from 'shared/utils/rolesHelper'

const useRolesAccess = () => {
  const { data: user } = useAppSelector(getUser)
  const activeClient = useAppSelector(getActiveClient)

  const roles = user?.roles.length ? user?.roles : []

  const hasBoardRole = hasBoardRoleForClient(roles, activeClient?.id)

  const hasBoardMemberRole = hasBoardMemberRolesForClient(
    roles,
    activeClient?.id
  )

  const hasAuditorRole = hasAuditorRolesForClient(roles, activeClient?.id)

  const hasJanitorRole = hasJanitorRoleForClient(roles, activeClient?.id)

  const hasCaretakerOrAuditorRole =
    hasAuditorRolesForClient(roles, activeClient?.id) ||
    hasCaretakerRolesForClient(roles, activeClient?.id)

  const hasOnlyCaretakerOrAuditorRole =
    !hasBoardRole && hasCaretakerOrAuditorRole

  const hasOnlyJanitorRole = !hasBoardRole && !hasAuditorRole && hasJanitorRole

  const hasDigitalKeyRole =
    !hasBoardRole && roles.some((x) => x.role === UserRoleEnum.digitalkeys)

  const hasOnlyAdvisorRole = hasOnlyStyrePortalBrukerAndAdvisor(
    roles,
    activeClient?.id
  )

  const hasOnlyFullAccessAdvisorRole = hasOnlyStyrePortalBrukerAndAdvisor(
    roles,
    activeClient?.id,
    true
  )

  const hasOwnerRoleSomeClients = hasOwnerAccess(roles)

  const hasPortalAccessAllClients = hasPortalAccess(roles.map((x) => x.role))

  const hasAdvisorRole = hasAdvisorRolesForClient(roles, activeClient?.id)

  const hasOnlyAdvisorRoleByClientId = (clientId: string) =>
    hasOnlyStyrePortalBrukerAndAdvisor(roles, clientId)

  const hasFullAccessAdvisorRole = hasAdvisorRolesForClient(
    roles,
    activeClient?.id,
    true
  )

  const hasRolesToAccessSigning = true

  const hasCEORole = hasCEORoleForClient(roles, activeClient?.id)

  return {
    hasBoardRole,
    hasBoardMemberRole,
    hasCaretakerOrAuditorRole,
    hasOnlyCaretakerOrAuditorRole,
    hasOnlyJanitorRole,
    hasDigitalKeyRole,
    hasOnlyAdvisorRole,
    hasOnlyFullAccessAdvisorRole,
    hasAdvisorRole,
    hasAuditorRole,
    hasJanitorRole,
    hasOnlyAdvisorRoleByClientId,
    hasOwnerRoleSomeClients,
    hasPortalAccessAllClients,
    hasFullAccessAdvisorRole,
    hasRolesToAccessSigning,
    hasCEORole,
  }
}

export default useRolesAccess
